import { cmsGlobal } from "@/common/fhtGlobalEnv";
import { assert } from "@/common/assert";

export function warn(message: string) {
    if (cmsGlobal.Env.DEBUG) {
        // eslint-disable-next-line no-alert
        alert(message);
    } else {
        console.error(message);
    }
}

export function IsBoolean<T>(value: T) {
    return typeof value === "boolean";
}
export function IsString<T>(value: T) {
    return typeof value === "string";
}
export function IsNumber<T>(value: T) {
    return typeof value === "number";
}

export function IsArray<T>(value: T) {
    return Object.prototype.toString.call(value) === "[object Array]";
}

export function IsObject<T>(value: T) {
    return typeof value === "object";
}
export function IsObjectOrArray<T>(value: T) {
    return IsObject(value) || IsArray(value);
}

export function unique<T>(array: T[]) {
    return $.grep(array, function (el, index) {
        return index === $.inArray(el, array);
    });
}

export function stripHTML(dangerousText: string): string {
    const container = document.createElement("div");
    const text = document.createTextNode(dangerousText);
    container.appendChild(text);
    return container.innerHTML; // innerHTML will be a xss safe string
}

export function ensureAttributesForSelector(selector: string, attrs: string[]) {
    $(selector).each(function (_index, el) {
        for (const attr of attrs) {
            const attributeValue = $(el).attr(attr);
            assert(attributeValue !== undefined, attr + " must exist for selector " + selector);
        }
    });
}

export function getUrlParam(name: string): string | null {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r !== null) return decodeURIComponent(r[2]);
    return null;
}

export async function loadScript(src: string): Promise<Event> {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = src;
    document.body.appendChild(s);
    return new Promise<Event>((res, rej) => {
        s.onload = (e) => res(e);
        s.onerror = rej;
    });
}

export function GetRandomNum(min:number, max:number):number {
   let range = max - min;
   let rand = Math.random();
   return (min + Math.round(rand * range));
}